import React from "react";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const ListItemStyled = styled("li")(({ theme }) => ({
  "&:hover": {
    background: `${theme.palette.blue100_1.main} !important`,
  },
  "& .text": {
    ...theme.typography.body1,
    "&.highlighted": {
      ...theme.typography.bold,
    },
  },
  "& .type": {
    ...theme.typography.body1bold,
    paddingLeft: 2,
  },
}));

const CustomOptionTemplate = (props, option, { inputValue }) => {
  let parts = option.value.split(new RegExp("(" + inputValue + ")", "gi"));
  const { key, ...other } = props;
  return (
    <ListItemStyled key={props.id + props.key} {...other}>
      <div>
        {parts.map(function (part, ind) {
          return (
            <span
              key={ind}
              className={`text ${
                part.toLowerCase() === inputValue.toLowerCase()
                  ? "highlighted"
                  : ""
              }`}
            >
              {part}
            </span>
          );
        })}
      </div>
      {option.type && <span className="type">({option.type})</span>}
    </ListItemStyled>
  );
};

export default CustomOptionTemplate;
